import { c as _c } from "react/compiler-runtime";
import type { NodeExecutionDetailConditional, NodeExecutionDetailRules, PublicTrace, PublicTraceEntry } from '@onefootprint/request-types/dashboard';
import { useTranslation } from 'react-i18next';
import Subsection from '../subsection';
import ConditionalNodeBranch from './components/conditional-node-branch';
import RulesNodeGroup from './components/rules-node-group';
type ObeRulesProps = {
  trace: PublicTrace;
};
const ObeRules = t0 => {
  const $ = _c(14);
  const {
    trace
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "onboardings.onboardingTrace"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  const isSuccessfulRuleTraceEntry = _temp;
  let T0;
  let allRuleEntries;
  let t2;
  if ($[1] !== trace) {
    allRuleEntries = trace?.entries.filter(isSuccessfulRuleTraceEntry) ?? [];
    T0 = Subsection;
    t2 = allRuleEntries.map((entry_0, i) => {
      const isFirstEntry = i === 0;
      const isLastEntry = i === allRuleEntries.length - 1;
      const node_0 = trace.graph.nodes.find(node => node.id === entry_0.decisionNodeId);
      if (entry_0.context) {
        if (entry_0.context.kind === "conditional") {
          return <ConditionalNodeBranch key={entry_0.decisionNodeId} context={entry_0.context as NodeExecutionDetailConditional} isFirstEntry={isFirstEntry} isLastEntry={isLastEntry} node={node_0} />;
        }
        if (entry_0.context.kind === "rules") {
          return <RulesNodeGroup key={entry_0.decisionNodeId} context={entry_0.context as NodeExecutionDetailRules} isFirstEntry={isFirstEntry} isLastEntry={isLastEntry} node={node_0} />;
        }
      }
      return null;
    });
    $[1] = trace;
    $[2] = T0;
    $[3] = allRuleEntries;
    $[4] = t2;
  } else {
    T0 = $[2];
    allRuleEntries = $[3];
    t2 = $[4];
  }
  let t3;
  if ($[5] !== allRuleEntries.length || $[6] !== t) {
    t3 = allRuleEntries.length ? null : <div className="flex flex-col gap-1"><span className="text-body-2 text-tertiary">{t(_temp2)}</span><span className="text-body-2 text-tertiary">{t(_temp3)}</span></div>;
    $[5] = allRuleEntries.length;
    $[6] = t;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = <div>{t2}{t3}</div>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== T0 || $[12] !== t4) {
    t5 = <T0>{t4}</T0>;
    $[11] = T0;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};
export default ObeRules;
function _temp(entry) {
  const isSuccessfulSignal = entry.result.signalKind === "proceed" || entry.result.signalKind === "halt";
  const isRuleNode = entry.nodeKind === "conditional" || entry.nodeKind === "rules";
  return isRuleNode && isSuccessfulSignal;
}
function _temp2($) {
  return $.rulesNotYetExecuted;
}
function _temp3($_0) {
  return $_0.openTrace;
}